import React from 'react';
import {
  FlutterDataPayload,
  GLOBAL_EVENTS,
  GLOBAL_FLUTTER_CHANNELS,
  REGISTER_EVENTS,
} from '@/components/utils/hooks/events/constants';

const POKER_EVENT_ID = {
  [REGISTER_EVENTS.FORM_READY]: 2, // received from poker app team: EWFS_LOADED_OK
  [REGISTER_EVENTS.FORM_UPLOAD_DOCUMENT]: 11, // received from poker app team
  [GLOBAL_EVENTS.FORM_FYU]: 999999993, // TODO: need to receive new one from poker app team
  [GLOBAL_EVENTS.FORM_FYP]: 999999994, // TODO: need to receive new one from poker app team
  [REGISTER_EVENTS.FORM_SUBMIT]: 9999995, // TODO: need to receive new one from poker app team
  [REGISTER_EVENTS.AUTO_LOGIN]: 700, // received from poker app team (example from draft version of document)
  [REGISTER_EVENTS.FORM_CLOSE]: 3, // received from poker app team
  [REGISTER_EVENTS.SERVER_OR_NETWORK_ERROR]: 1, // received from poker app team (ID example from draft version of document was 777)
  [GLOBAL_EVENTS.CHANGE_LANGUAGE]: 999999999, // TODO: need to receive new one from poker app team
  [GLOBAL_EVENTS.CHANGE_CURRENCY]: 999999990, // TODO: need to receive new one from poker app team
};

type PokerEventData = {
  ActionId: number;
  payload: {
    [key: string | number]: any;
  };
  timestamp: string;
};

/**
 * usePokerEvents
 */
export function usePokerEvents() {
  const isPokerEventActive = React.useMemo(() => {
    return (
      // @ts-ignore
      window.external?.CallToAction &&
      // @ts-ignore
      typeof window.external.CallToAction === 'function' &&
      // @ts-ignore
      window.config.appEnv === 'poker'
    );
  }, []);

  const send = React.useMemo(() => {
    let funct = (data: string) => {};
    // @ts-ignore
    if (isPokerEventActive) {
      // @ts-ignore
      funct = window.external.CallToAction;
    }
    return funct;
  }, [isPokerEventActive]);

  const callFunction = React.useCallback(
    (channel: string, payload: FlutterDataPayload) => {
      if (isPokerEventActive && channel === GLOBAL_FLUTTER_CHANNELS.POKER_APP_EVENT && payload.event) {
        const eventId = POKER_EVENT_ID[payload.event];
        const payloadInfo = { ...payload };
        // @ts-ignore remove event from payloadIndo
        delete payloadInfo.event;

        const data: PokerEventData = {
          ActionId: eventId,
          payload: { ...payloadInfo },
          timestamp: new Date().toISOString(),
        };
        send(JSON.stringify(data));
      }
    },
    [isPokerEventActive, send],
  );

  return React.useMemo(
    () => ({
      callHandler: callFunction,
      isPokerEventActive,
    }),
    [callFunction, isPokerEventActive],
  );
}